import { Form } from 'factorial-form'

import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { coerceValueFromType } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/coerceValueFromType'
import { getValueType } from 'modules/custom_resources/components/CustomFields/CustomFieldsForm/getValueType'
import { isEditable } from 'modules/custom_resources/lib/utils'
import type CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'
import type CustomValue from 'modules/custom_resources/store/models/customFields/Value'
import type Employee from 'modules/employees/store/models/Employee'

export const createForm = (
  customField: CustomField | ResourceField,
  customFieldValues: CustomValue[] | null | undefined = undefined,
  contractVersions: ContractVersions,
  employee?: Employee
) => {
  const data = () => {
    if (!customFieldValues) return {}

    const prevCustomFieldValue = customFieldValues.find(
      (value: CustomValue) => value.attributes.field_id === customField.attributes.field_id
    )

    if (prevCustomFieldValue) {
      return {
        ...prevCustomFieldValue.toJS(),
        editable: isEditable(customField.attributes.editable, contractVersions, employee),
        value: coerceValueFromType(prevCustomFieldValue, customField),
      }
    }

    return {}
  }

  const withNullLabel =
    customField.attributes.field_type === 'date'
      ? i18n.t('settings.custom_fields.remove_date')
      : customField.has('withNullLabel') && customField.attributes.withNullLabel

  const values = {
    editable: isEditable(customField.attributes.editable, contractVersions, employee),
    field_id: customField.attributes.field_id,
    field_type: customField.attributes.field_type,
    installed: customField.attributes.installed,
    mandatory: customField.attributes.required,
    name: customField.attributes.label,
    options: customField.attributes.options,
    choice_options: customField.attributes.choice_options,
    min_value: customField.attributes.min_value,
    max_value: customField.attributes.max_value,
    resource_id: customField.attributes.id,
    withNullLabel,
    // TODO: This is broken.
    // The API returns permission-like visibilities which are not
    // compatible with the frontend
    visible: null,
    ...data(),
  }

  const form = new Form(values, {
    installed: 'boolean',
    editable: 'boolean',
    field_id: 'number',
    field_type: 'string',
    mandatory: 'boolean',
    name: 'string',
    options: 'string',
    choice_options: 'string',
    min_value: 'number',
    max_value: 'number',
    resource_id: 'string',
    withNullLabel: 'string',
    value: getValueType(customField),
    visible: 'any',
  })

  return form
}
